import axios from 'axios'

// Initialize Pinch SDK
const capture = Pinch.Capture({
    publishableKey: process.env.VUE_APP_PINCH_API_KEY,
});

export const createPinchPayer = async (user) => {
  const options = {
    method: 'POST',
    url: `/api/pinch/payer`,
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
    },
    data: {
      id: user.pinch_payer_id,
      fullName: user.name,
      emailAddress: user.email,
      companyName: user.business_name,
      phoneNumber: user.phone,
      streetAddress: user.address,
      state: user.state,
      companyRegistrationNumber: user.abn,
    },
    skipInterceptor: true,
  };

  try {
    const { data } = await axios.request(options)
    return data.data.id;
  } catch (error) {
    console.log('createPinchPayer error: ', { error })
  }
}

export const getPayer = async ({ payerId }) => {
  const options = {
    method: 'GET',
    url: `/api/pinch/payers/${payerId}`,
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
    },
    skipInterceptor: true,
  };

    return axios.request(options)
}

export const createCardToken = async ({
  cardHolderName,
  cardNumber,
  expiryMonth,
  expiryYear,
  cvc,
}) => {
    let response = null

    await capture
      .createToken({
        sourceType: 'credit-card',
        cardNumber: cardNumber,
        expiryMonth: expiryMonth,
        expiryYear: expiryYear,
        cvc: cvc,
        cardHolderName: cardHolderName,
      })
      .then(function (result) {
        response = result
      })
      .catch(function (errors) {
        response = { errors }
    });
    return response;
}

export const createPaymentSource = async ({ payerId, creditCardToken }) => {
  const options = {
    method: 'POST',
    url: `/api/pinch/payers/${payerId}/source`,
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
    },
    data: {
      sourceType: 'credit-card',
      creditCardToken,
    },
    skipInterceptor: true,
  }

  return axios.request(options)
}

export const deletePaymentSource = async ({ payerId, sourceId }) => {
  const options = {
    method: 'DELETE',
    url: `/api/pinch/payers/${payerId}/sources/${sourceId}`,
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
    },
    skipInterceptor: true,
  };

  return axios.request(options)
}

export const createPayment = async ({
    payerId = undefined,
    sourceId = undefined,
    creditCardToken = undefined, // payment using another card
    fullName = undefined, // payment using another card
    email,
    amount,
    description,
}) => {
  if (!sourceId && !creditCardToken) {
    throw new Error('Either sourceId or creditCardToken must be provided')
  }

  const options = {
    method: 'POST',
    url: `/api/pinch/payment`,
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
    },
    data: {
      email,
      amount,
      description,
      creditCardToken,
      fullName,
      payerId,
      sourceId,
    },
    skipInterceptor: true,
  };

  return await axios.request(options)
}
